<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import TeamGeneratorPage from '../../Teacher/Gamification/Groups/MainTeams/partials/TeamGeneratorPage.vue';
import PanelPage from '../../../Shared/PanelPage.vue';

export default {
    props: {
        meta: Object,
        nexa: Object,
    },
    components: {
        PanelPage,
        TeamGeneratorPage,
        SmartBreadcrumbs,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <PanelPage>
        <template v-slot:title>
            <div class="bg-gray-100 mb-2">
                <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
                    <SmartBreadcrumbs
                        type="InertiaLink"
                        :pages="[
                            {
                                name: $t('landing.user_roles'),
                                href: meta.links.landing,
                            },
                            {
                                name: $tc('messages.teachers', 2),

                                href: meta.links.teachers,
                            },

                            {
                                name: $t('messages.nexa'),
                                href: meta.links.nexa,
                            },
                        ]"
                    />
                </div>
            </div>
        </template>
        <TeamGeneratorPage
            :teams="nexa.teams"
            :students-not-in-team="[]"
            :all-students="nexa.allStudents"
            :links="nexa.links"
            :info="nexa.info"
            :table="nexa.table"
            :sociogram-survey="nexa.sociogramSurvey"
            :groupings="[]"
            is-demo
            :grouping="{ name: 'demo' }"
        />
    </PanelPage>
</template>
